import { ShareService } from './share.service';

export default angular
  .module('sfMobile.services.share', [])
  .service('shareService', ShareService).name;
